import styled from 'styled-components';
import { Body1Styles } from '../typography';
import { getSizeBy, getColorShade, getColor } from '../../../src/styled/utils';
export const Label = styled.label `
  position: relative;
  display: inline-block;
  margin-bottom: ${getSizeBy(1)};
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  ${Body1Styles};
`;
export const TooltipContentWrapper = styled.div `
  position: absolute;
  display: inline-block;
`;
export const Asterisk = styled.span.attrs({ 'aria-hidden': true }) `
  display: inline-block;
  padding: ${getSizeBy(0.5)} ${getSizeBy(0.5)} ${getSizeBy(0)} ${getSizeBy(1)};
  color: ${getColor('danger')};
  vertical-align: middle;
`;
